import React, { useEffect, useRef } from 'react';
import backgroundImage from '../images/awards-image.png';
import { AwardsCarousel, Button } from '../components';
import img1 from '../images/awards/international-award-1-2023.webp';
import img2 from '../images/awards/international-award2023.webp';
import img3 from '../images/awards/Best-Advisory-Asia-2022.webp';
import img4 from '../images/awards/Emerging-talent-Sam-Ebss-2022.webp';
import img5 from '../images/awards/Excellence-in-client-services-Asia-2022.webp';
import img6 from '../images/awards/excellence-in-Client-Services-ME-2022.webp';
import img7 from '../images/awards/Personality-of-Year-2022-Riyad.webp';
import img8 from '../images/awards/Unsung-Hero-Rubina-2022.webp';
import img9 from '../images/awards/Emerging-talent-Sam-Ebss-2022.webp';
import img10 from '../images/awards/Excellence-in-client-services-Asia-2022.webp';

const images = [
    { src: img1 },
    { src: img2 },
    { src: img3 },
    { src: img4 },
    { src: img5 },
    { src: img6 },
    { src: img7 },
    { src: img8 },
    { src: img9 },
    { src: img10 },
];
const groupedImages = [];
for (let i = 0; i < images.length; i += 5) {
    groupedImages.push(images.slice(i, i + 5));
}

const AwardWinning = () => {
    const trustpilotWidgetRef = useRef(null);

    useEffect(() => {
        // Function to attempt reinitialization of Trustpilot widgets
        const reinitializeTrustpilotWidgets = () => {
            if (window.Trustpilot && trustpilotWidgetRef.current) {
                window.Trustpilot.loadFromElement(trustpilotWidgetRef.current, true);
            }
        };

        // Observe the entire body for the addition of child elements if needed
        // You might not need a MutationObserver if you're just initializing once on component mount

        // Ensure Trustpilot widgets are reinitialized on initial load
        reinitializeTrustpilotWidgets();

        // Optionally, you might set up a MutationObserver or other logic here if you need to detect dynamic changes
    }, []);

    return (
        <div className="award-winning lg:flex">
            <div className="w-full lg:w-1/2 bg-cover bg-no-repeat bg-center pt-80 lg:pt-0" style={{ backgroundImage: `url(${backgroundImage})` }}></div>
            <div className="w-full lg:w-1/2 items-center justify-center text-center p-12">
                <h3 className="text-2xl font-semibold">We're multi-award-winning financial experts</h3>
                <p className="pb-8">We've won several awards celebrating our excellent customer service and are highly rated on Trustpilot, so you have peace of mind that your assets are safe with us.</p>
                <div
                    ref={trustpilotWidgetRef}
                    className="trustpilot-widget pb-8"
                    data-locale="en-GB"
                    data-template-id="5419b6ffb0d04a076446a9af"
                    data-businessunit-id="58bff1ac0000ff00059e0e97"
                    data-style-height="20px"
                    data-style-width="100%"
                    data-theme="light">
                </div>

                <div className="grid grid-cols-12 mb-12 mt-4">
                    <div className="col-span-12 lg:col-start-2 lg:col-span-10">
                        <AwardsCarousel />
                    </div>
                </div>
                <Button color="holborn-green" href="/enquiry-form/">
                    Book a consultation
                </Button>
            </div>
        </div>
    );
};

export default AwardWinning;